import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {DokumentBakgrunnDirektiv, DokumentFilnavnDirektiv, DokumentHandlingDirektiv, DokumentKomponent} from "web-ng2/delt/komponenter/dokument/dokument";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";
import {Opplasting} from "felles-ng2/tjenester/filopplasting/SekvensiellFilopplasting";
import {MatIcon} from "@angular/material/icon";
import {DokumentFormatIkonKomponent} from "../dokument-format-ikon/dokument-format-ikon";

const debug = initDebugger('DokumentOpplastingKortvisningKomponent');

/**
 * Kortvisning av dokument som er i ferd med å lastes opp
 */
@Component({
    selector: 'dokument-opplasting-kortvisning',
    templateUrl: 'dokument-opplasting-kortvisning.html',
    styleUrl: 'dokument-opplasting-kortvisning.scss',
    host: {
        '[class]': 'opplasting().status()',
        'data-testid': 'dokument-opplasting'
    },
    imports: [
        DokumentBakgrunnDirektiv,
        DokumentFilnavnDirektiv,
        DokumentHandlingDirektiv,
        DokumentKomponent,
        MatProgressSpinner,
        MatTooltip,
        TranslateModule,
        MatIcon,
        DokumentFormatIkonKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentOpplastingKortvisningKomponent<M> {

    vedAvbryt = output();
    opplasting = input.required<Opplasting<M>>();

    visAvbryt = computed(() => ['venter', 'lasteropp'].includes(this.opplasting().status()));

    constructor() {
    }

    avbryt() {
        this.vedAvbryt.emit();
    }
}
